<template>
  <div>

    <div v-if="isLoading" class="my-4 mt-3 text-center">
      <scale-loader />
    </div>

    <div v-else class="block mt-3 text-sm uppercase  text-blue-light">
      <span v-if="pictogram" class="font-semibold basis-9">{{ _totalPictograms }}</span>
      <span>{{ !pictogram ? $t("no_certifiers_found") : ($t("pictogram") + ' ' + $t("linked")) }}</span>
      <button class="w-9 h-9 rounded-full bg-gray-200 float-right"
        type="button"
        @click="handleWorkMonitoring">
        <b-icon :icon="_workMonitoringIcon" pack="fas"></b-icon>
      </button>
    </div>

    <div class="my-4" v-if="pictogram">
      <pictograms-table
        :list-layers='_listLayers'
        :pictogram="pictogram"
        :activityId="activityId"
        :subactivityId="subactivityId"
        @epc-open-modal="handleOpenViewerPictogram"
      />
    </div>

    <konva-preview
      v-if="_isMechanical"
      :ref="'konva_preview_modal'"
      :can-actions-pictogram="canActionsPictogram"
      @epc-reload="() => { $emit('epc-reload') }" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PictogramsTable from './components/pictogram-table.vue'
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import KonvaPreview from './viewer-pixi/konva-preview-modal.vue';
import { PICTOGRAM_TYPES } from './constants/pictogram-types';

export default {
  name: "pictogram-table-activity",

  components: {
    ScaleLoader,
    PictogramsTable,
    KonvaPreview
  },

  props: {
    pictogram: { type: Object, require: true },
    canManageCertifiers: { type: Boolean, default: false },
    assignmentsLocked: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    activityId: { type: Number, default: null },
    subactivityId: { type: Number, default: null }
  },

  data() {
    return {
      selected: undefined,
      selectedHistory: undefined,
      selectedSubHistory: undefined,

      canActionsPictogram: {
        'save': false,
        'select_entity': false,
        'view_only': true,
        showButtonReturn: false,
        showButtonInfo: false,
      }
    }
  },

  computed: {
    ...mapGetters({
      locale: "lang/locale",
      project: 'app/project',
    }),

    _listLayers() {
      if (!this.pictogram) return []

      // Clonado superficial para no mutar el prop. Cada layer se copia con spread —
      // los campos derivados (progress, statuses_progress, total_execute, children)
      // se setean sobre la copia, no sobre la fuente.
      const meta = this.pictogram.metadata || {}
      const totalProgress    = meta.total_progress    || {}
      const statusesProgress = meta.statuses_progress || {}

      const layers = (this.pictogram.layers || []).map((src) => {
        const layer = { ...src }

        layer.progress = totalProgress[layer.code] || 0

        // statuses_progress por capa: si no hay registro, dejamos un placeholder
        // con el total declarado bajo la clave "-1" (sin estado). Si tampoco
        // existe el total en metadata, queda objeto vacío.
        if (statusesProgress[layer.code]) {
          layer.statuses_progress = statusesProgress[layer.code]
        } else {
          const fallbackTotal = meta['total_' + layer.code]
          layer.statuses_progress = fallbackTotal != null ? { '-1': fallbackTotal } : {}
        }

        layer.total_execute = meta['total_' + layer.code]
        layer.children = []
        return layer
      })

      // Sort sobre la copia (no muta el prop).
      // ordenamos la lista por order_column
      return layers.sort((a, b) => {
        if (a.order_column < b.order_column) return -1
        if (a.order_column > b.order_column) return 1
        return 0
      })
    },

    _totalPictograms() {
      return this.pictogram ? 1 : 0
    },

    _workMonitoringIcon() {
      if (!this.pictogram) return 'solar-panel'
      switch (this.pictogram.type) {
        case PICTOGRAM_TYPES.ELECTRICAL: return 'bolt'
        case PICTOGRAM_TYPES.DITCHES:    return 'road'
        default:                         return 'solar-panel' // mecánico
      }
    },

    _isMechanical() {
      return this.pictogram && this.pictogram.type === PICTOGRAM_TYPES.MECHANICAL
    }
  },

  watch: {
  },
  created() {

  },
  mounted() {

  },

  methods: {
    displayDetails(rowId){
      this.selected = (this.selected == rowId) ? undefined : rowId;
    },

    displayHistory(rowId){

      this.selectedHistory = (this.selectedHistory == rowId) ? undefined : rowId;
    },

    displaySubHistory(rowId){

      this.selectedSubHistory = (this.selectedSubHistory == rowId) ? undefined : rowId;
    },

    handleOpenViewerPictogram(e) {
      // Para pictogramas no-mecánicos (electrical_installation, electrical_trenches,
      // etc.) no se persiste scene JSON ni Components en Mongo, así que el
      // viewer-konva no aplica. Redirigimos al LayoutBuilder que descarga el
      // DXF remoto y lo re-parsea en cliente.
      if (this.pictogram && this.pictogram.type !== PICTOGRAM_TYPES.MECHANICAL) {
        this.$router.push({
          name:   'project.admin.pictogram.view',
          params: { id: String(this.pictogram.id) },
        })
        return
      }

      this.canActionsPictogram.save = true
      this.canActionsPictogram.select_entity = true
      this.canActionsPictogram.view_only = false
      this.$refs.konva_preview_modal.show(this.pictogram, e.code)
    },

    handleWorkMonitoring() {
      // Para electrical/trenches el visor cliente vive aparte (futuro componente),
      // no usa konva-preview. Redirigimos al LayoutBuilder en modo lectura.
      if (this.pictogram && this.pictogram.type !== PICTOGRAM_TYPES.MECHANICAL) {
        this.$router.push({
          name:   'project.admin.pictogram.view',
          params: { id: String(this.pictogram.id) },
        })
        return
      }

      this.canActionsPictogram.save = false
      this.canActionsPictogram.select_entity = false
      this.canActionsPictogram.view_only = true
      this.$refs.konva_preview_modal.show(this.pictogram)
    }
  },
};
</script>

<style lang="scss" scoped>
  table, tr {
    border: 1px solid #ADC2EA;
  }
</style>
